import { GiftWithPurchaseObject, ProcessedGiftWithPurchaseObject } from './gwp.types'
import { formatMoney } from './utils'
import { Cart } from './cart.types'

export function processGift(gift: GiftWithPurchaseObject, cart: Cart): ProcessedGiftWithPurchaseObject {
  const minPurchaseAmount = gift.minPurchaseType === 'amount' ? (gift.convertMinPurchaseValue ? gift.minPurchaseValue * window.Shopify.currency.rate : gift.minPurchaseValue) * 100 : 0
  const maxPurchaseAmount = gift.maxPurchaseType === 'amount' ? (gift.convertMaxPurchaseValue ? gift.maxPurchaseValue * window.Shopify.currency.rate : gift.maxPurchaseValue) * 100 : 0
  const minPurchaseQuantity = gift.minPurchaseType === 'quantity' ? gift.minPurchaseValue : 0
  const maxPurchaseQuantity = gift.maxPurchaseType === 'quantity' ? gift.maxPurchaseValue : 0
  const { qualifyingAmount, qualifyingQuantity } = cart.items
    .filter((item) => !('_bl_gwp' in item.properties))
    .reduce(({ qualifyingAmount, qualifyingQuantity }, item) => {
      switch (gift.conditionalType) {
        case 'products':
          if (gift.conditionalIds.includes(`gid://shopify/Product/${item.product_id}`)) {
            return {
              qualifyingAmount: qualifyingAmount + item.final_line_price,
              qualifyingQuantity: qualifyingQuantity + item.quantity
            }
          }
          break
        case 'collections':
          for (const collection of item.collections || []) {
            if (gift.conditionalIds.includes(`gid://shopify/Collection/${collection.id}`)) {
              return {
                qualifyingAmount: qualifyingAmount + item.final_line_price,
                qualifyingQuantity: qualifyingQuantity + item.quantity
              }
            }
          }
          break
        case 'tags':
          for (const tag of item.tags || []) {
            if (gift.conditionalTags.includes(tag)) {
              return {
                qualifyingAmount: qualifyingAmount + item.final_line_price,
                qualifyingQuantity: qualifyingQuantity + item.quantity
              }
            }
          }
          break
        default:
          return {
            qualifyingAmount: qualifyingAmount + item.final_line_price,
            qualifyingQuantity: qualifyingQuantity + item.quantity
          }
      }
      return {
        qualifyingAmount,
        qualifyingQuantity
      }
    }, { qualifyingAmount: 0, qualifyingQuantity: 0 })
  const giftInCart = cart.items.some((item) => {
    switch (gift.giftType) {
      case 'products':
        if (gift.giftIds.includes(`gid://shopify/Product/${item.product_id}`) && item.properties._bl_gwp === gift.id.split('/').pop()) {
          return true
        }
        break
      case 'collections':
        for (const collection of item.collections || []) {
          if (gift.giftIds.includes(`gid://shopify/Collection/${collection.id}`) && item.properties._bl_gwp === gift.id.split('/').pop()) {
            return true
          }
        }
        break
    }
    return false
  })
  const giftCodeRequired = (gift.codes && gift.codes.nodes.length > 0) || false
  const giftCodeApplied = giftCodeRequired && cart.discount_applications.some(discount => discount.type === 'discount_code' && discount.title === gift.codes?.nodes[0]?.code)
  const cartQualifies =
    qualifyingAmount > 0 &&
    qualifyingAmount >= minPurchaseAmount &&
    qualifyingQuantity >= minPurchaseQuantity &&
    (maxPurchaseAmount === 0 || qualifyingAmount <= maxPurchaseAmount) &&
    (maxPurchaseQuantity === 0 || qualifyingQuantity <= maxPurchaseQuantity) &&
    (!giftCodeRequired || giftCodeApplied)

  let message = ''
  if (gift.giftType === 'shipping') {
    if (qualifyingAmount < minPurchaseAmount) {
      message = `Spend ${formatMoney(minPurchaseAmount - qualifyingAmount)} more to get ${gift.giftName}`
    } else {
      message = `You qualify for ${gift.giftName}`
    }
  } else {
    const messageActions = []
    if (!gift.customerQualifies) {
      messageActions.push('join the club')
    }
    if (giftCodeRequired && !giftCodeApplied) {
      messageActions.push(`apply code "${gift.codes?.nodes[0]?.code}"`)
    }
    if (gift.minPurchaseType === 'amount' && qualifyingAmount < minPurchaseAmount) {
      messageActions.push(`spend ${formatMoney(minPurchaseAmount - qualifyingAmount)} more`)
    } else if (gift.minPurchaseType === 'quantity' && qualifyingQuantity < minPurchaseQuantity) {
      messageActions.push(`add ${minPurchaseQuantity - qualifyingQuantity} more item${minPurchaseQuantity - qualifyingQuantity > 1 ? 's' : ''}`)
    }
    if (messageActions.length > 0) {
      messageActions.forEach((action, index) => {
        if (index === 0) {
          // Uppercase the first letter of the action
          message = action.charAt(0).toUpperCase() + action.slice(1)
        } else {
          if (index === messageActions.length - 1) {
            message += ` and ${action}`
          } else {
            message += `, ${action}`
          }
        }
      })
      message += ` to get a ${gift.giftName}`
    } else {
      message = `You qualify for a ${gift.giftName}`
    }
  }

  return {
    ...gift,
    minPurchaseAmount,
    maxPurchaseAmount,
    minPurchaseQuantity,
    maxPurchaseQuantity,
    qualifyingAmount,
    qualifyingQuantity,
    cartQualifies,
    giftInCart,
    message
  }
}
